import Icon from "@ant-design/icons";

const LocationOutlinedSvg = () => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 261 369"
		fill="none"
		xmlns="http://www.w3.org/2000/svg">
		<path
			d="M130.277 0C58.594 0 0.277008 58.317 0.277008 130C0.277008 217.26 119.465 359.855 124.54 365.883C125.957 367.568 128.044 368.543 130.245 368.553C130.256 368.553 130.266 368.553 130.277 368.553C132.466 368.553 134.548 367.596 135.973 365.932C141.048 360.006 260.277 219.767 260.277 130C260.276 58.317 201.96 0 130.277 0ZM130.322 349.251C106.385 319.48 15.277 201.453 15.277 130C15.277 66.589 66.866 15 130.277 15C193.688 15 245.277 66.589 245.277 130C245.276 203.49 154.327 319.829 130.322 349.251Z"
			fill="currentColor"
		/>
		<path
			d="M130.277 72.293C99.801 72.293 75.008 97.086 75.008 127.562C75.008 158.038 99.801 182.831 130.277 182.831C160.753 182.831 185.546 158.038 185.546 127.562C185.546 97.086 160.753 72.293 130.277 72.293ZM130.277 167.83C108.073 167.83 90.008 149.766 90.008 127.561C90.008 105.356 108.072 87.292 130.277 87.292C152.482 87.292 170.546 105.356 170.546 127.561C170.546 149.766 152.48 167.83 130.277 167.83Z"
			fill="currentColor"
		/>
	</svg>
);
export const LocationOutlinedIcon = props => <Icon component={LocationOutlinedSvg} {...props} />;
